export default __webpack_public_path__ + "static/CLUB-8-0ccf405249db85070e315e93a4873f17.png";